import { render, staticRenderFns } from "./holiday-change.vue?vue&type=template&id=571f95d4&scoped=true"
import script from "./holiday-change.vue?vue&type=script&lang=js"
export * from "./holiday-change.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f95d4",
  null
  
)

export default component.exports